module.exports = {
      id: "share-pintrest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#share-pintrest",
      toString: function () {
        return this.url;
      }
    }